import connectToStores from 'alt-utils/lib/connectToStores'
import { ExtendedUserActions } from 'actions'
import { ExtendedUserStore } from 'stores'
import { SimpleDialog, Loading, HelpEmail } from 'components'
import Immutable from 'immutable'
import { API_BASE } from 'consts'

@connectToStores
export default class ShopifyLoginContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    currentUser: React.PropTypes.object,
    authenticated: React.PropTypes.bool.isRequired
  }

  componentWillMount() {
    const token = this.props.params.token

    if (token)
      ExtendedUserActions.getCurrent(token)
    else
      this.context.router.replace('/')
  }

  componentDidUpdate() {
    if (this.props.shopifyUserFetchFailed === false && this.context.currentUser && this.context.authenticated) {
      const { query } = this.props.location

      if (query.origin) {
        const url = new URL(query.origin)

        // we don't want to redirect to the login pages
        if (url.pathname !== "/login" && url.pathname !== "/users/sign_in") {
          return window.location = query.origin
        }
      }

      if (!query.app_link)
        this.context.router.replace('/checks')
      else {
        const params = Object.keys(query).map(key => `${key}=${query[key]}`).join('&')
        this.context.router.replace(`/checks/seoproblems/applink?${params}`,)
      }
    }
  }

  static getStores() {
    return [ExtendedUserStore]
  }

  static getPropsFromStores() {
    return ExtendedUserStore.getState()
  }

  onDialogClose() {
    window.location = `${API_BASE}/login` // Shopify base app served by Rails
  }

  render() {
    if (this.props.shopifyUserFetchFailed === true) {
      return (
        <SimpleDialog
          title='Shopify login failed'
          message={<div>Error: Could not log you in from Shopify. Please email <HelpEmail /> with this error message</div>}
          open={true}
          onClose={::this.onDialogClose}
        />
      )
    } else {
      return <Loading />
    }
  }
}



// WEBPACK FOOTER //
// ./app/containers/ShopifyLoginContainer.js